import { Controller } from "@hotwired/stimulus"

const key = "noble-capybara.sms.inbox-return"

// Server-rendered filter/page links can reorder parameters without changing
// the view. Compare URLs by value so Back to inbox still restores its position.
function sameInboxLocation(savedUrl) {
    try {
        const current = new URL(window.location.pathname + window.location.search, window.location.origin)
        const saved = new URL(savedUrl, window.location.origin)
        if (saved.origin !== current.origin || !/^\/admin\/sms\/?$/.test(saved.pathname)) return false
        for (const url of [current, saved]) {
            url.pathname = url.pathname.replace(/\/$/, "")
            url.searchParams.sort()
            url.hash = ""
        }
        return current.href === saved.href
    } catch { return false }
}

// Store navigation metadata only, never contact names or message contents.
export class SmsNavigationController extends Controller {
    static targets = ["back"]

    connect() {
        let saved
        try { saved = JSON.parse(sessionStorage.getItem(key)) } catch { /* storage is optional */ }
        if (this.hasBackTarget) {
            try {
                if (saved && !new URL(this.backTarget.href).search) {
                    const url = new URL(saved.url, window.location.origin)
                    if (url.origin === window.location.origin && /^\/admin\/sms\/?$/.test(url.pathname)) this.backTarget.href = url.href
                }
            } catch { /* Ignore malformed or tampered navigation metadata. */ }
        } else {
            if (saved?.restore && sameInboxLocation(saved.url) && Number.isFinite(saved.scroll)) {
                requestAnimationFrame(() => window.scrollTo(0, saved.scroll))
                try { sessionStorage.setItem(key, JSON.stringify({ ...saved, restore: false })) } catch { /* optional */ }
            }
            this.clicked = event => {
                const link = event.target.closest("a")
                if (!link || !/^\/admin\/sms\/conversation\/\d+$/.test(new URL(link.href).pathname)) return
                try { sessionStorage.setItem(key, JSON.stringify({ url: window.location.pathname + window.location.search, scroll: window.scrollY, restore: true })) } catch { /* optional */ }
            }
            this.element.addEventListener("click", this.clicked)
        }
    }

    disconnect() { if (this.clicked) this.element.removeEventListener("click", this.clicked) }
}
